import { Close } from "@mui/icons-material";
import { Box, IconButton, TextField } from "@mui/material";
import MDAutocomplete from "components/MDAutocomplete";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import React from "react";
// import { Input, CustomInput } from "reactstrap";

export const Filter = ({ column }) => {
  return <div style={{ marginTop: 5 }}>{column.canFilter && column.render("Filter")}</div>;
};

export const DefaultColumnFilter = ({
  column: { filterValue, setFilter, filterInputType, filterOptions, id, filterLabel },
}) => {
  let inputComponent = null;

  switch (filterInputType) {
    case "text":
      inputComponent = (
        <TextField
          type="text"
          value={filterValue || ""}
          size="small"
          variant="outlined"
          placeholder={`Filter by ${filterLabel || id.replace("_", " ")}`}
          onChange={(e) => {
            setFilter(e.target.value || undefined);
          }}
          InputProps={{
            endAdornment: (
              <IconButton
                disabled={!filterValue}
                size="small"
                onClick={() => {
                  setFilter(undefined);
                }}
              >
                <Close />
              </IconButton>
            ),
          }}
        />
      );
      break;
    case "number":
      inputComponent = (
        <TextField
          type="number"
          value={filterValue || ""}
          size="small"
          variant="outlined"
          placeholder={`Filter by ${filterLabel ||  id.replace("_", " ")}`}
          onChange={(e) => {
            const value = e.target.value;
            // Check for valid number format - only one decimal point and one negative sign at start
            if (value === "" || /^-?\d*\.?\d*$/.test(value)) {
              // Prevent multiple decimal points
              const decimalCount = (value.match(/\./g) || []).length;
              // Prevent multiple negative signs and only allow negative at start
              const negativeCount = (value.match(/-/g) || []).length;
              
              if (decimalCount <= 1 && negativeCount <= 1 && (!value.includes('-') || value.indexOf('-') === 0)) {
                setFilter(value || undefined);
              }
            }
          }}
          onKeyDown={(e) => {
            // Get current value
            const currentValue = e.target.value;
            
            // Prevent multiple decimal points
            if (e.key === '.' && currentValue.includes('.')) {
              e.preventDefault();
              return;
            }
            
            // Prevent multiple negative signs or negative sign in middle
            if (e.key === '-') {
              if (currentValue.includes('-') || e.target.selectionStart > 0) {
                e.preventDefault();
                return;
              }
            }
            
            // Allow negative sign, decimal point, numbers, and control keys
            if (!/[-\d.]/.test(e.key) && 
                e.key !== 'Backspace' && 
                e.key !== 'Delete' && 
                e.key !== 'ArrowLeft' && 
                e.key !== 'ArrowRight' &&
                e.key !== 'Tab') {
              e.preventDefault();
            }
          }}
          InputProps={{
            endAdornment: (
              <IconButton
                disabled={!filterValue}
                size="small"
                onClick={() => {
                  setFilter(undefined);
                }}
              >
                <Close />
              </IconButton>
            ),
          }}
        />
      );
      break;
    case "select":
      inputComponent = (
        <MDAutocomplete
          value={filterValue || null}
          options={filterOptions}
          onChange={(e, newValue) => {
            setFilter(newValue?.value || undefined);
          }}
          placeholder={`Filter by ${filterLabel || id.replace("_", " ")}`}
          size="small"
          sx={{ width: "auto", minWidth: 150 }}
          renderInput={(params) => <TextField {...params} placeholder={`Filter by ${filterLabel || id}`} />}
        />
      );
      break;
    case "date":
      const date = filterValue ? moment(filterValue) : null;
      inputComponent = (
        <DatePicker
          value={date}
          onChange={(newValue) => {
            const tempNewValue = newValue ? moment(newValue).format("MM/DD/YYYY") : null;
            setFilter(tempNewValue || undefined);
          }}
          sx={{ width: 200 }}
          format="MM/DD/YYYY"
          inputRef={{ size: "small" }}
          slotProps={{
            textField: {
              size: "small",
              clearable: true,
              onClear: (event) => {},
            },
          }}
        />
      );
      break;
    default:
      inputComponent = (
        <>
          <Box sx={{ mb: 4.5 }}></Box>
        </>
      );
  }

  return inputComponent;
};
